import React, { useEffect, useRef } from "react";
import hljs from "highlight.js/lib/core";
import java from "highlight.js/lib/languages/java";
import cpp from "highlight.js/lib/languages/cpp";
import python from "highlight.js/lib/languages/python";
import c from "highlight.js/lib/languages/c";
import javascript from "highlight.js/lib/languages/javascript";
import "highlight.js/styles/github.css"; // use any style you like
import "./highlightedCode.css"
// Register only the required languages
hljs.registerLanguage("java", java);
hljs.registerLanguage("cpp", cpp);
hljs.registerLanguage("python", python);
hljs.registerLanguage("c", c);
hljs.registerLanguage("javascript", javascript);

const HighlightedCode = ({ codeHTML }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const blocks = containerRef.current.querySelectorAll("pre code");
    blocks.forEach((block) => {
      hljs.highlightElement(block);
    });
  }, [codeHTML]);

  return (
    <div
      ref={containerRef}
      className="code-container"
      dangerouslySetInnerHTML={{ __html: codeHTML }}
    />
  );
};

export default HighlightedCode;
